<template>
  <div class="overviewTable">
    <modal id="deleteObject">
      <h3>{{ deleteTitle }}</h3>
      <br />
      <span v-html="deleteText(objectToDelete)"></span><br />
      <br />
      <a @click="doDelete()">Ja</a>
      &nbsp;
      <a @click="closeModal()">Nein</a>
    </modal>
    <input v-model="search" class="c-field" placeholder="Suche" />
    <table class="table table-striped">
      <thead>
        <tr>
          <th v-for="column in this.columns" :key="column.key">
            <a
              @click="sortBy(column.key)"
              :class="sortKey == column.key ? 'active' : ''"
            >
              {{ column.name }}
            </a>
          </th>
          <th></th>
        </tr>
      </thead>

      <tbody v-if="filteredList.length > 0" class="dataList">
        <tr v-for="item in filteredList" :key="item._id">
          <td v-for="column in columns" :key="column.key">
            {{ item[column.key] }}
          </td>
          <td class="icons">
            <bos-button
              ghost
              icon
              @click="onEdit(item)"
              v-if="onEdit !== undefined"
            >
              <font-awesome-icon icon="edit" />
            </bos-button>
            <bos-button
              icon
              color="red"
              @click="markForDeletion(item)"
              v-if="onDelete !== undefined && !disableDelete(item)"
            >
              <font-awesome-icon icon="trash" />
            </bos-button>
            <bos-button
              icon
              color="red"
              :disabled="true"
              v-if="onDelete !== undefined && disableDelete(item)"
            >
              <font-awesome-icon icon="trash" />
            </bos-button>
          </td>
        </tr>
      </tbody>
      <tbody v-if="filteredList.length == 0">
        <tr>
          <td colspan="3">Keine Einträge gefunden</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import BosButton from '@/components/BosButton'

export default {
  name: 'OverviewTable',
  components: { Modal, BosButton },
  data() {
    return {
      sortKey: null,
      reverse: false,
      search: '',
      objectToDelete: {}
    }
  },
  props: {
    onEdit: {
      type: Function
    },
    onDelete: {
      type: Function
    },
    disableDelete: {
      type: Function,
      default: () => {
        return false
      }
    },
    deleteTitle: {
      type: String,
      default: 'Löschen'
    },
    deleteText: {
      type: Function,
      default: () => {
        return 'Soll dieser Eintrag wirklich gelöscht werden?'
      }
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    sortBy: function(sortKey) {
      this.reverse = this.sortKey === sortKey ? !this.reverse : false
      this.sortKey = sortKey
    },
    doDelete: function() {
      this.onDelete(this.objectToDelete)
      this.objectToDelete = {}
      this.closeModal()
    },
    markForDeletion: function(item) {
      this.objectToDelete = item
      this.$root.$emit('modal:deleteObject:show')
    },
    closeModal: function() {
      this.$root.$emit('modal:deleteObject:hide')
    }
  },
  computed: {
    filteredList: function() {
      const self = this
      let retVal = self.data.slice(0)
      if (self.search.length > 0) {
        retVal = self.data.filter(function(item) {
          for (let i = 0; i < self.columns.length; i++) {
            if (
              item[self.columns[i].key]
                .toLowerCase()
                .indexOf(self.search.toLowerCase()) > -1
            ) {
              return true
            }
          }
          return false
        })
      }

      let localSortKey = this.sortKey

      retVal.sort(function(a, b) {
        let checkA = a[localSortKey]
        let checkB = b[localSortKey]

        if (self.reverse) {
          return checkA < checkB ? 1 : -1
        } else {
          return checkA > checkB ? 1 : -1
        }
      })

      return retVal
    }
  },
  mounted() {
    this.sortKey = this.columns[0].key
  }
}
</script>

<style scoped lang="scss">
a {
  color: #42b983;
}

.table-striped {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 10px;

  .active {
    font-weight: bold;
    text-decoration: underline;
  }

  th {
    padding: 8px;
    vertical-align: bottom;
    border-bottom: 2px solid #ddd;
  }

  td {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;

    &.icons {
      text-align: right;
    }
  }

  tbody.dataList {
    tr {
      &:nth-of-type(even) {
        background-color: #f7f6f3;
      }
    }
  }
}
</style>
